import { ISpacing } from "../types";

export const spacing: ISpacing = {
    "spacing-6x-small": "0.125",
    "spacing-5x-small": "0.25",
    "spacing-4x-small": "0.375",
    "spacing-3x-small": "0.5",
    "spacing-xx-small": "0.625",
    "spacing-x-small": "0.75",
    "spacing-small": "0.875",
    "spacing-regular": "1",
    "spacing-medium": "1.25",
    "spacing-large": "1.5",
    "spacing-x-large": "1.75",
    "spacing-xx-large": "2",
    "spacing-3x-large": "2.25",
    "spacing-4x-large": "2.5",
    "spacing-5x-large": ".275",
    "spacing-6x-large": "3",
    "spacing-7x-large": "3.5",
    "spacing-8x-large": "4",
    "spacing-9x-large": "5",
    "spacing-10x-large": "6",
    "spacing-11x-large": "7",
    "spacing-12x-large": "8",
    "spacing-13x-large": "9",
    "spacing-14x-large": "10",
    "spacing-15x-large": "11",
    "spacing-16x-large": "12",
    "spacing-17x-large": "13",
    "spacing-18x-large": "14",
    "spacing-19x-large": "15",
    "spacing-20x-large": "16"
};
